<template>
  <div class="content">
    <el-dialog v-bind="$attrs" v-on="$listeners" @open="onOpen" title="新增">
      <el-row :gutter="15">
        <el-form
          ref="addRef"
          :model="roleInfo"
          :rules="rules"
          size="medium"
          label-width="100px"
          label-position="top"
        >
          <el-col :span="12">
            <el-form-item label="名称" prop="name">
              <el-input
                v-model="roleInfo.name"
                clearable
                disabled
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="编码" prop="code">
              <el-input
                disabled
                v-model="roleInfo.code"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="描述" prop="description">
              <el-input
                disabled
                v-model="roleInfo.description"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业" prop="companyId">
              <el-input
                disabled
                v-model="roleInfo.companyId"
                clearable
                :style="{ width: '100%' }"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-table
            ref="table"
            :data="tableData"
            style="width: 100%; margin-bottom: 20px"
            row-key="id"
            border
            default-expand-all
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            @selection-change="handleSelectionChange"
          >
            <el-table-column prop="name" label="菜单名称" sortable width="180">
            </el-table-column>
            <el-table-column prop="address" label="功能">
              <template slot-scope="scope">
                <!-- <el-checkbox
                  v-if="scope.row.authorityIdList > 1"
                  :indeterminate="scope.row.indeterminate"
                  v-model="scope.row.checkAll"
                  @change="
                    () => handleCheckAllChange(scope.row.checkAll, scope.row)
                  "
                  >全选</el-checkbox
                >
                <div style="margin: 15px 0"></div> -->
                <el-checkbox-group
                  v-model="scope.row.authorityIdList"
                  @change="
                    () => {
                      handleCheckedCitiesChange(
                        scope.row.authorityIdList,
                        scope.row
                      );
                    }
                  "
                >
                  <el-checkbox
                    v-for="item in scope.row.authorityList"
                    :label="item.id"
                    :key="item.id"
                    >{{ item.authName }}</el-checkbox
                  >
                </el-checkbox-group>
              </template>
            </el-table-column>
          </el-table>

          <!-- <el-col :span="8">
            <el-form-item label="名称">
              <el-select
                v-model="otherForm.roleAppSystemRelForm.idList"
                placeholder="请选择名称"
                multiple
                clearable
                :style="{ width: '100%' }"
              >
                <el-option
                  v-for="(item, index) in appSystemNameOptions"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-form>
      </el-row>
      <div slot="footer" v-if="true">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handelConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getAuthByMenu,assignRoleAuth}  from '@/api/systemData'

const cityOptions = ["上海", "北京", "广州", "深圳"];
export default {
  inheritAttrs: false,
  props: ["data"],
  data() {
    return {
      resultAuth:[],
      checkboxDatas: [],
      checkAll: false,
      // checkedCities: ["上海", "北京"],
      cities: ["上海", "北京", "广州", "深圳"],
      authFun: [
        { id: 1, authName: "新增" },
        { id: 2, authName: "编辑" },
        { id: 3, authName: "删除" },
        { id: 4, authName: "查询" },
      ],
      isIndeterminate: true,
      roleInfo: {
        name: "",
        code: "",
        description: "",
        companyId:""
      },
      otherForm: {
        roleAppSystemRelForm: {
          id: "",
          idList: [],
        },
      },
      rules: {
        name: [
          {
            required: true,
            message: "名称不能为空",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "编码不能为空",
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: "描述不能为空",
            trigger: "blur",
          },
        ],
        companyId: [
          {
            required: true,
            message: "企业不能为空",
            trigger: "blur",
          },
        ],
      },
      appSystemNameOptions: [],
      tableData: [
        {
          id: 3,
          name: "员工",
          indeterminate: true,
          authorityIdList: [2],
          authorityList: [
            { id: 1, authName: "新增" },
            { id: 2, authName: "编辑" },
          ],
          checkAll: false,
          children: [
            {
              id: 31,
              name: "角色",
              indeterminate: true,
              authorityIdList: [4],
              authorityList: [
                { id: 3, authName: "删除" },
                { id: 4, authName: "查询" },
              ],
            },
            {
              id: 32,
              name: "组织机构",
              indeterminate: true,
              authorityIdList: [3],
              authorityList: [
                { id: 1, authName: "新增" },
                { id: 2, authName: "编辑" },
                { id: 3, authName: "删除" },
                { id: 4, authName: "查询" },
              ],
            },
          ],
        },
      ],
      result: [],
      selectedRows: [],
      allCheckedNodeId: [],
      checkedArr: [],
    };
  },
  computed: {},
  watch: {
    data: {
      deep: true,
      handler(newData) {
        let newValue = {
          ...newData,
        };

        this.roleInfo = newValue;
      },
    },
  },
  created() {
    // this.getAppSystemNameOptions();
  },
  mounted() {},
  methods: {
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    clickRow(row, column, event) {
      this.$refs.Table.toggleRowSelection(row);
    },
    checkRowChange(data) {
      console.log("data", data);
    },
    getAllIds(tree, result) {
      if (!Array.isArray(tree)) return []; // 如果不是一个数组，则返回
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i];

        if (node.authorityIdList.length > 0) {
          node.authorityIdList.forEach((item) => {
            result.push(item); // 存储当前节点的id
          });
        }

        if (Array.isArray(node.children)) {
          // 如果当前节点有子节点，则递归遍历子节点
          this.getAllIds(node.children, result);
        }
      }

      return result;
    },
    getAuthRoleMenu(roleId) {
      console.log("roleId",roleId);
      // let appSystemCode = "yyzc";
      getAuthByMenu(roleId).then((res) => {
        console.log("res",res);
        if (res.code == 10000) {
          this.tableData = res.data;
        }
      });
    },
    async getAuthority() {
      let res = await getAllAuthority();
      this.authFun = res.data;
    },
    handleCheckAllChange(val, row) {
      let newArr = [];
      row.authorityList.forEach((item) => {
        newArr.push(item.id);
      });
      row.authorityIdList = val ? newArr : [];
      row.indeterminate = false;
    },
    handleCheckedCitiesChange(value, row) {
      console.log("value", value);
      let checkedCount = value.length;
      row.checkAll = checkedCount === row.authorityList.length;
      row.indeterminate =
        checkedCount > 0 && checkedCount < row.authorityList.length;

      this.result = [];
    },
    onOpen() {},
    onClose() {
      this.$refs["addRef"].resetFields();
    },
    close() {
      this.$emit("update:visible", false);
    },
    // 向上获取父Id
    treeFindPath(tree, func, field = "", path = []) {
      if (!tree) return [];
      for (const data of tree) {
        field === "" ? path.push(data) : path.push(data[field]);
        if (func(data)) return path;
        if (data.children) {
          const findChildren = this.treeFindPath(
            data.children,
            func,
            field,
            path
          );
          if (findChildren.length) return findChildren;
        }
        path.pop();
      }
      return [];
    },
    // 处理所有节点父Id并返回
    detailAllPid(id) {
      let arr = this.treeFindPath(
        this.tableData,
        (data) => data.id == id,
        "id"
      );
      arr.forEach((item) => {
        if(this.checkedArr.includes(item)){
          this.checkedArr.slice(item)
        }else{
          this.checkedArr.push(item); // 将每个节点父id存储
        }
      });
      this.checkedArr = [...new Set(this.checkedArr)]; // 数组去重
    },
    // 获取全部选中节点Id
    getAllNodeIds(tree, result) {
      if (!Array.isArray(tree)) return []; // 如果不是一个数组，则返回
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.authorityIdList.length > 0) {
          result.push(node.id); // 存储当前节点的id
        }
        if (Array.isArray(node.children)) {
          // 如果当前节点有子节点，则递归遍历子节点
          this.getAllNodeIds(node.children, result);
        }
      }

      return result;
    },
    // 获取每个节点id的父id
    getPidArr() {
      this.checkedArr = [];

      this.getAllNodeIds(this.tableData, this.allCheckedNodeId); // 获取所有选中的的节点id数组，存储咋allNodeId
      this.allCheckedNodeId.forEach((item) => {
        this.detailAllPid(item);
      });
    },
    // takeDetailAuth(obj){
    //   console.log("obj",obj);
    //   if(obj == null || obj.length == 0) return;
    //   for(let i =0;i<obj.length;i++){
    //     if(obj[i].authorityIdList.length ==0){
    //       if(obj[i].children != null){
    //         this.resultAuth.push( obj[i].id);
    //         this.takeDetailAuth(obj[i].children);
    //       }
    //     }else{
    //       this.resultAuth.push( obj[i].id);
    //       for(let j =0;j<obj[i].authorityIdList.length;j++){
    //         if(obj[i].id == obj[i].authorityIdList[j]){
    //           continue;
    //         }
    //         this.resultAuth.push( obj[i].authorityIdList[j]);
    //       }
    //       if(obj[i].children != null && obj[i].children.length > 0){
    //         this.takeDetailAuth(obj[i].children);
    //       }
    //     }
    //   }
    // },

    // takeDetailAuth(obj,arr=[]){
    //   console.log("obj",obj);
    //   if(obj == null || obj.length == 0) return;
    //   for(let i =0;i<obj.length;i++){
    //     if(obj[i].authorityIdList.length ==0){
    //       if(obj[i].children != null){
    //         // this.resultAuth.push( obj[i].id);
    //         arr.push(obj[i].id);
    //         this.takeDetailAuth(obj[i].children,arr);
    //       }
    //     }else{
    //       this.resultAuth.push(...arr);
    //       this.resultAuth.push( obj[i].id);
    //       console.log("this.resultAuth++++++",this.resultAuth);
    //       for(let j =0;j<obj[i].authorityIdList.length;j++){
    //         if(obj[i].id == obj[i].authorityIdList[j]){
    //           continue;
    //         }
    //         this.resultAuth.push( obj[i].authorityIdList[j]);
    //       }
    //       if(obj[i].children != null ){
    //         this.takeDetailAuth(obj[i].children);
    //       }
    //     }
    //   }
    // },
    // handelConfirm() {
    //   this.resultAuth = [];
    //   console.log("this.resultAuth",this.resultAuth);

    //   console.log("this.tableData",this.tableData);
    //   this.takeDetailAuth(this.tableData,[]);
    //   console.log("this.resultAuth",this.resultAuth);
    //   // return;
    //   // this.getAllIds(this.tableData, this.result);

    //   // this.getPidArr();
    //   console.log("this.tableData",this.tableData);
    //   let form = {};
    //   form.roleId = this.roleInfo.id;
    //   // form.authorityIdList = this.result;
    //   // form.menuIdList = this.checkedArr;
    //   form.authorityIdList = this.resultAuth;
    //   console.log("this.form", form);
    //   // return;
    //   assignRoleAuth(form).then((res) => {
    //     if (res.code == 10000) {
    //       let data = res.data;
    //       this.allCheckedNodeId = [];
    //       this.checkedArr = [];

    //       this.$emit("add-success");
    //       this.close();
    //     }
    //   });
    // },

     // 收集所有有权限的节点（菜单id + 权限id）
     takeDetailAuth(obj) {
        if (!obj || obj.length === 0) return;
        
        for (let i = 0; i < obj.length; i++) {
            const node = obj[i];
            const hasAuth = node.authorityIdList && node.authorityIdList.length > 0;
            
            if (hasAuth) {
                // 菜单节点 id
                this.resultAuth.push(node.id);
                
                // 功能权限 id（去重，避免和菜单 id 重复）
                node.authorityIdList.forEach(authId => {
                    if (authId !== node.id) {
                        this.resultAuth.push(authId);
                    }
                });
            }
            
            // 递归子节点
            if (node.children && node.children.length > 0) {
                this.takeDetailAuth(node.children);
            }
        }
    },
    
    handelConfirm() {
        this.resultAuth = [];
        this.takeDetailAuth(this.tableData);
        
        // 去重（防止同一 id 被多次添加）
        this.resultAuth = [...new Set(this.resultAuth)];
        
        console.log("提交的数据:", this.resultAuth);
        
        let form = {
            roleId: this.roleInfo.id,
            authorityIdList: this.resultAuth
        };
        
        assignRoleAuth(form).then((res) => {
            if (res.code == 10000) {
                this.$emit("add-success");
                this.close();
            }
        });
    },
    getAppSystemNameOptions() {
      // 注意：this.$axios是通过Vue.prototype.$axios = axios挂载产生的
      this.$axios({
        method: "get",
        url: "/api/yys/appSystem/getAll",
      }).then((resp) => {
        let { data } = resp;
        let list = data.data;
        const newOptions = list.map((item) => {
          return {
            value: item["id"],
            label: item["appSystemName"],
          };
        });
        this.appSystemNameOptions = newOptions;
        // this.appSystemNameOptions = data.undefined
      });
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  background-color: #fff;
  padding: 10px;
}
::v-deep .el-dialog__body {
  padding: 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  height: 600px;
  overflow: auto;
}
</style>
